import React from 'react';
import PTERAResearch from './components/PTERAResearch';
import './App.css';

function App() {
  return (
    <div className="app">
      <PTERAResearch />
    </div>
  );
}

export default App;


